export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-voronoi/src/constant.js
// module id = 953
// module chunks = 0